import i18n from 'i18next';
import * as yup from 'yup';

import { DeclineFeedbackFormData, ReasonInputFormData } from '../../types';

const declineFeedbackValidationSchema = () => yup.object({
    primaryReason: yup.string()
        .oneOf([ 'availability', 'location', 'company', 'role', 'skills', 'schedule', 'other' ] as const)
        .required(),
    freeText: yup.string().defined(),
    reasonInput: yup.mixed()
        .nullable()
        .default(null)
        .test({
            name: 'complete-date-range',
            test: function(value: unknown) {
                const reasonInput = value as ReasonInputFormData | null | undefined;

                if (!reasonInput || reasonInput.type !== 'availability') {
                    return true;
                }

                if (!isValidDateRange(reasonInput.value)) {
                    return this.createError({
                        path: 'reasonInput.value',
                        message: i18n.t('validation:dateRangeIncomplete')
                    });
                }

                return true;
            }
        })
}) as yup.ObjectSchema<DeclineFeedbackFormData>;

/**
 * Validates availability date range:
 * - Both dates null → valid (no dates selected)
 * - Both dates set → valid (complete range)
 * - Only one date set → invalid (incomplete range)
 */
function isValidDateRange(value: [Date | null, Date | null] | undefined): boolean {
    if (!value) {
        return true;
    }

    const [ startDate, endDate ] = value;
    const hasStart = startDate !== null;
    const hasEnd = endDate !== null;

    return hasStart === hasEnd;
}

export default declineFeedbackValidationSchema;
